export default "__VITE_ASSET__BdhsgABH__"